(function($, window, document) {
    "use strict";
    $(function() {
        //##Variables
        var $body = $('body'),
            $window = $(window),
            $doc = $(document),
            $openPopup = $('.play_button'),
            $popUp = $('.popup'),
            $close_popup = $('.close-popup'),
            defaultEasing = [0.4, 0.0, 0.2, 1],
            hasWhiteBgRemoved = false;
        var owl = $('.owl-carousel2');

        //End Variables
        //Header scroll animation
        $(document).scroll(function() {
            if ($(document).scrollTop() >= $('#header').outerHeight()) {
                $('#header').addClass('is--sticky');
            } else {
                $('#header').removeClass('is--sticky');
            }
        });

        $openPopup.click(function() {  
            $('.iframe_src').html($('<iframe src="'+$('#videoUrlIframe').val()+'?autoplay=1" frameborder="0" id="ytPlayer"  scrolling="no"></iframe>'));
            if ($popUp.is(':visible')) {
                $body.removeClass('popup_opened'); 
                $popUp.fadeIn('fast');
            } else {
                $body.addClass('popup_opened'); 
                $popUp.fadeOut('fast');
            }
            $(this).toggleClass('toggled');
            $popUp.fadeToggle('fast');
        });

        // Close popup on x button

        $close_popup.click(function() {
            $popUp.fadeOut('fast');
            $body.removeClass('popup_opened')
            $('.iframe_src').find('iframe').remove();
            var iframe = document.getElementById('ytPlayer');
            iframe.src = iframe.src;
        });


        // ----Hamburger menu---//
        $('#hamburger_btn').click(function(e) {
            e.preventDefault();
            $(this).toggleClass("active");
            if($(this).find('span[data-aos-duration="900"]'))
                $(this).find('span[data-aos-duration="900"]').attr('data-aos-duration',300);
    
            $("#header").stop().toggleClass("header_white");
            $(".header_menu_title").stop().fadeToggle(500).toggleClass("active");
            $(".hamburger_menu_toggle").stop().fadeToggle(500).toggleClass("active");

            if ($(this).hasClass('active')) {
                $('#about_logo').children().css({ stroke: "#b87d5c" });
                if ($('#hamburger_btn').hasClass('hamburger_white_bg')) {
                    $('#hamburger_btn').removeClass('hamburger_white_bg');
                    hasWhiteBgRemoved = true;
                }
            } else {
                if (hasWhiteBgRemoved) {
                    $('#hamburger_btn').addClass('hamburger_white_bg');
                    hasWhiteBgRemoved = false;
                }
                $('#about_logo').children().css({ stroke: "#fff" });
            }
            lockScroll();
        });

        function lockScroll() {
            if ($('body').hasClass('lock_scroll')) {
                $('body').removeClass('lock_scroll');
            } else {
                $('body').addClass('lock_scroll');
            }
        }
        // Slider 
        owl.owlCarousel({
            items:1,
            loop: true,
            nav:false,
            autoplay:false,
            dots:true,
            animateIn: true,
            autoplayTimeout: 5000
        });

       

        $(document).ready(function() {
          $('.owl-home-slider').addClass('sliderAnimate');
          $('.vertical-line').addClass('line-animate');
          $('.skewed-line').addClass('skewed-animate');
          $('.hamburger_btn').addClass('hamburger-animate');
          //  setTimeout(function(){ 
          //   $(".banner_title").addClass("main_title_animated"); 
          // },1500)
            changeMenuBgInProducts();
            manageAutoPlaySlider();
            changeViewPort();
        });

        // Media Query - hamburger menu 
        $(window).resize(function(){
           changeMenuBgInProducts();
        });

        function changeMenuBgInProducts() {
            if ($("#hamburger_btn").hasClass("products")) {
                 if ($(window).width() <= 1024){
                    $("#hamburger_btn").addClass('hamburger_white_bg');
                } else {
                    $("#hamburger_btn").removeClass('hamburger_white_bg');
                }
            }
        }

        // Manage slider autoplay in different devices
        function manageAutoPlaySlider() {
            if ($(window).width() > 1024){
                owl.hover(function() {
                    /* Stuff to do when the mouse enters the element */
                     $(this).trigger('play.owl.autoplay',[5000]);
                }, function() {
                    /* Stuff to do when the mouse leaves the element */
                    $(this).trigger('stop.owl.autoplay');
                });
            } else {
                owl.trigger('play.owl.autoplay',[5000]);
            }
        }

        // Animations
        $.fn.animateText = function (options) {
            var el = this;

            if ($(el).length < 1) {
                return;
            }
 
            options = options ? options : {}
            var delay = options.delay ? options.delay : 500;

            $(el).addClass('text-animated-element'); 
            $(el).addClass('text-animated-cover'); 

            function playAnimation() {
                $(el).removeClass('text-animated-show'); 
                $(el).addClass('text-animated-cover'); 

                setTimeout(function(){
                    $(el).removeClass('text-animated-cover'); 
                    $(el).addClass('text-animated-show');
                }, delay);
                
                if (options.onDoneStop == true) {
                    el.data('done-animating', true)
                }
            }

            function animateOnElementInView() {
                var $onVisibleOfElement = options.animateOnVisible === true ? $(el) : $(options.animateOnVisible)

                var top_of_element = $onVisibleOfElement.offset().top;
                var bottom_of_element = $onVisibleOfElement.offset().top + $onVisibleOfElement.outerHeight();

                var bottom_of_screen = $(window).scrollTop() + window.innerHeight;
                var top_of_screen = $(window).scrollTop();
     

                if (bottom_of_screen > top_of_element && top_of_screen < bottom_of_element && el.data('done-animating') !== true) {
                    playAnimation();
                }
            }

            if (options.animateOnVisible) {
                animateOnElementInView();
                
                $(window).scroll(function() {
                    animateOnElementInView();
                });
            } else {
                playAnimation();
            }
        }
          
        $('.animate-text').animateText()


          
        $('.animate-text-onscroll').animateText({
            delay: 0,
            onDoneStop: true,
            animateOnVisible: '.animate_section'
        })

          
        $('.animate-text-onscroll-2').animateText({
            delay: 0,
            onDoneStop: true,
            animateOnVisible: '.animate_section_2'
        })
        $('.animate-text-onscroll-footer').animateText({
            delay: 0,
            onDoneStop: true,
            animateOnVisible: '.animate_section_footer'
        })
        $('.animate-text-onscroll-related-inspirations').animateText({
            delay: 500,
            onDoneStop: true,
            animateOnVisible: '.animate_section_related_inspirations'
        })
        $('.animate-text-onscroll-third').animateText({
            delay: 500,
            onDoneStop: true,
            animateOnVisible: '.animate_section_third'
        })
        $('.animate-text-onscroll-second').animateText({
            delay: 500,
            onDoneStop: true,
            animateOnVisible: '.animate_section_second'
        })
        $('.animate-text-onscroll-last').animateText({
            delay: 500,
            onDoneStop: true,
            animateOnVisible: '.animate_section_last'
        })

        // Home slider - synchronize text change
        var $homeSlider = $('.owl-home-slider').owlCarousel({
            items:1,
            loop: true,
            nav:false,
            autoplay:true,
            dots:true, 
            animateOut: 'fadeOut',
            autoplayTimeout: 5000,
            onInitialized: function (e) {
                var currentActiveEl = $('.owl-home-slider').find('.owl-item').get(2);

                $('#slider-home-text').html($(currentActiveEl).find('.slide-text').html())


                $('#slider-home-text').animateText()
            },
            onChanged: function (e) {
                var currentActiveEl = $('.owl-home-slider').find('.owl-item').get(e.item.index);

                $('#slider-home-text').html($(currentActiveEl).find('.slide-text').html())
                
                $('#slider-home-text').animateText()
            }
        });

        // Replace divs on hover

         if ($(window).width() > 1024){
             $('.slider_following_text').hover(function() {
                $(this).find('.project_item').hide();
                $(this).find('.project_item_bcg').fadeIn();
            }, function() {
                $(this).find('.project_item_bcg').hide();
                $(this).find('.project_item').fadeIn();
            });
        } else {
            $(this).find('.project_item').css("display", "none");
            $(this).find('.project_item_bcg').css("display", "block");
        }

        // Change ViewPort Height because of status bar and vh issue
        function changeViewPort() {
            if ($(window).width() <= 1024){
                var windowHeight = window.innerHeight;
                var documentHeight = document.documentElement.clientHeight;
                var deltaViewPort = windowHeight - documentHeight;
                var viewPort = windowHeight - deltaViewPort;
                $(".static_main_content").css({
                    height: viewPort
                });
            }
        } 

        // $( window ).on( "orientationchange", function( event ) {
        //     window.location.reload();
        // });
        window.addEventListener("orientationchange", function() {
            var windowHeight = window.innerHeight;
            var documentHeight = document.documentElement.clientHeight;
            var deltaViewPort = windowHeight - documentHeight;
            var viewPort = windowHeight - deltaViewPort;
            
            $(".static_main_content").css({
                height: viewPort
            });
        });
        //AOS init
        // AOS.init();

        console.log("%c Developed by: Kutia Digital Agency http://kutia.net", "padding:9px 5px; background:#3c4952; line-height:25px;color: #59bf9d");
    });
}(window.jQuery, window, document));